import React from 'react'
import styled from 'styled-components'
import useShop from '../context/AppContext'
import { Helmet } from 'react-helmet'
import { motion } from 'framer-motion'
import { Layout } from '../layout'

const MainWrapper = styled.div`
  overflow: hidden;
  width: 100%;
  padding: 140px 0;
  @media screen and (max-width: 800px) {
    padding: 90px 0;
  }
`
const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 86%;
  max-width: var(--max-width);
  margin: 0 auto;
  color: var(--text);
  @media screen and (max-width: 800px) {
    width: calc(100% - 50px);
    margin: 0 25px;
  }
  h1 {
    margin-bottom: 60px;
  }
  h3 {
    margin-bottom: 5px;
  }
  h4 {
    padding-top: 5px;
  }
  p {
    margin-bottom: 15px;
  }
  a {
    color: var(--secondary) !important;
    &:hover {
      color: var(--grey-medium) !important;
    }
  }
`

const Cookie = () => {
  const { preloaderExecuted, navigationExecuted } = useShop()
  const title = <h1>Cookie Policy</h1>
  const body = (
    <>
      <p>data...</p>
    </>
  )

  return (
    <Layout>
      <Helmet>
        <title>Robert Eberhard's Imprint</title>
      </Helmet>
      <MainWrapper>
        <MainContainer>
          {preloaderExecuted && navigationExecuted ? (
            <>
              <motion.div animate={{ y: [30, 0], opacity: [0, 1] }} transition={{ delay: 0.1, duration: 0.5 }} className="start-opacity">
                {title}
              </motion.div>
              <motion.div animate={{ y: [30, 0], opacity: [0, 1] }} transition={{ delay: 0.2, duration: 0.5 }} className="start-opacity">
                {body}
              </motion.div>
            </>
          ) : (
            <>
              <motion.div animate={{ y: [30, 0], opacity: [0, 1] }} transition={{ delay: 0.8, duration: 0.5 }} className="start-opacity">
                {title}
              </motion.div>
              <motion.div animate={{ y: [30, 0], opacity: [0, 1] }} transition={{ delay: 0.9, duration: 0.5 }} className="start-opacity">
                {body}
              </motion.div>
            </>
          )}
        </MainContainer>
      </MainWrapper>
    </Layout>
  )
}

export default Cookie
